import { TimelineNode } from "@gymflow/api";
import { ApiListResponse } from "@gymflow/types";
import { AxiosInstance } from "axios";

import { createSortParam } from "../createSortParam";

export type TimelineApiType = ReturnType<typeof timelineApi>;

const timelineApi = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;
  return {
    find({
      page = 0,
      limit = 10,
      extraParams = {},
      sort,
    }: {
      readonly extraParams: {
        readonly userMemberId?: string;
        readonly leadId?: number;
        readonly [k: string]: any;
      };
      readonly page?: number;
      readonly limit?: number;
      readonly sort?: {
        readonly field: string;
        readonly desc?: boolean;
      };
    }) {
      const config = {
        params: {
          page,
          size: limit,
          ...extraParams,
        },
      } as any;
      if (sort) {
        config.params.sort = createSortParam(sort);
      }

      return axiosInstance.get<ApiListResponse<TimelineNode>>(
        `${clubPrefix}timeline`,
        config,
      );
    },
  };
};

export default timelineApi;
